import { render, staticRenderFns } from "./CreatePackageItem.vue?vue&type=template&id=55c0a0f8&scoped=true&"
import script from "./CreatePackageItem.vue?vue&type=script&lang=js&"
export * from "./CreatePackageItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c0a0f8",
  null
  
)

export default component.exports